import { render, staticRenderFns } from "./EmployeeEditTabInformation.vue?vue&type=template&id=51843652"
import script from "./EmployeeEditTabInformation.vue?vue&type=script&lang=js"
export * from "./EmployeeEditTabInformation.vue?vue&type=script&lang=js"
import style0 from "./EmployeeEditTabInformation.vue?vue&type=style&index=0&id=51843652&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports